import React from "react";
import { focusLabel, formatAcquisition, confidenceLabel } from "../../../../../utils/alertFocusPoints";
const muted = { color: "var(--text-secondary)" };

const Field = ({ label, value }) =>
  value ? (
    <div>
      <div style={{ ...muted, fontSize: 12 }}>{label}</div>
      <div style={{ fontSize: 14 }}>{value}</div>
    </div>
  ) : null;

export default function FocusPointsSection({ points }) {
  if (!points.length) {
    return (
      <p style={muted}>Nenhum ponto de foco registrado para este alerta.</p>
    );
  }

  const insideCount = points.filter((p) => p.inside_area).length;
  const nearest = points[0];

  return (
    <div>
      {/* Resumo */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 12,
        }}
      >
        {/* Alterado para Verde da paleta global */}
        <span style={chip("var(--accent-secondary)")}>
          {points.length} {points.length === 1 ? "foco" : "focos"}
        </span>

        {insideCount > 0 && (
          /* Vermelho Vivo */
          <span style={chip("#dc2626")}>
            {insideCount} dentro da propriedade
          </span>
        )}

        {focusLabel(nearest) && (
          /* Alterado para Verde da paleta global */
          <span style={chip("var(--accent-secondary)")}>
            Mais próximo: {focusLabel(nearest)}
          </span>
        )}
      </div>

      <p style={{ ...muted, fontSize: 13, margin: "0 0 10px" }}>
        Ordenados do foco mais próximo ao mais distante da propriedade (KML).
      </p>

      <div style={{ display: "grid", gap: 10 }}>
        {points.map((p, i) => {
          const color = p.inside_area
            ? "#dc2626" // Vermelho Vivo (Tailwind red-600)
            : "#f97316"; // Laranja Vivo (Tailwind orange-500)

          return (
            <div
              key={`${p.lat}-${p.lon}-${i}`}
              style={{
                border: "1px solid var(--border-subtle)",
                borderLeft: `4px solid ${color}`,
                borderRadius: 12,
                padding: 12,
                background: "var(--surface-1)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 8,
                }}
              >
                <strong>
                  Foco {i + 1} · {p.lat}, {p.lon}
                </strong>
              </div>

              {focusLabel(p) && (
                <div style={{ marginTop: 4, color, fontWeight: 600 }}>
                  {focusLabel(p)}
                </div>
              )}

              {p.coordinates_minutes && (
                <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 2 }}>
                  📍 {p.coordinates_minutes}
                </div>
              )}

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                  gap: 10,
                  marginTop: 10,
                }}
              >
                <Field
                  label="Detecção"
                  value={
                    p.acq_date || p.acq_time
                      ? formatAcquisition(p.acq_date, p.acq_time)
                      : ""
                  }
                />
                <Field label="Satélite" value={p.satellite} />
                <Field label="Instrumento" value={p.instrument} />
                <Field label="Confiança" value={confidenceLabel(p.confidence)} />
                <Field label="Potência (FRP)" value={p.frp != null ? `${p.frp} MW` : ""} />
                <Field label="Brilho" value={p.brightness != null ? `${p.brightness} K` : ""} />
                <Field label="Fonte FIRMS" value={p.firms_query_source} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const chip = (color) => ({
  border: `1px solid ${color}`,
  color: color,
  borderRadius: 999,
  padding: "2px 10px",
  fontSize: 12,
  fontWeight: 600,
});